import {adminUserDogSexFilterChoices, breederChoices} from '@/lib/choices';
import {StatusChip} from '@/components/StatusChip';
import {formatOwnerDogCounts} from '@/utils/formatOwnerDogCounts';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import {
    BooleanField,
    Datagrid,
    DateField,
    FunctionField,
    List, SearchInput,
    SelectInput,
    TextField,
} from 'react-admin';

const filters = [
    <SearchInput
        key="search"
        source="q"
        alwaysOn
        placeholder="Name, email, or phone"
        size="small"
    />,
    <SelectInput
        key="is_registered_breeder"
        source="is_registered_breeder"
        label="Breeder"
        emptyText="All"
        choices={breederChoices}
        alwaysOn
        size="small"
    />,
    <SelectInput
        key="sex"
        source="sex"
        label="Dogs on account"
        emptyText="Any"
        choices={adminUserDogSexFilterChoices}
        helperText="Users with at least one dog of this sex (not the owner's gender)."
        alwaysOn
        size="small"
    />,
];

export const UserList = () => (
    <List filters={filters} perPage={25} empty={false} sort={{field: 'last_name', order: 'ASC'}}>
        <Datagrid bulkActionButtons={false}>
            <TextField source="first_name" />
            <TextField source="last_name" />
            <FunctionField
                label="Role"
                render={(user) =>
                    user.is_admin ? (
                        <StatusChip
                            intent="accent"
                            icon={<AdminPanelSettingsIcon />}
                            label="Admin"
                        />
                    ) : null
                }
                sortable={false}
            />
            <BooleanField source="is_registered_breeder" label="Breeder" />
            <TextField source="email" />
            <TextField source="phone_number" sortable={false}/>
            <FunctionField
                label="Dogs"
                render={(user) => formatOwnerDogCounts(user)}
                sortable={false}
            />
            <DateField
                source="updated_at"
                label="Last update"
                sortable={false}
            />
        </Datagrid>
    </List>
);
